import * as React from 'react'
import styled from '@emotion/styled'
import { PrimaryButton } from './styles'
import SadSmiley from './ui/SadSmiley'
import { mq } from './breakpoints'

const WidgetMyBooster = () => {
  return (
    <>
      <StopBox>
        <StopAlert>Stop !</StopAlert>
        <StopText>
          <strong>Vous avez du reste à charge ! <SadSmiley/></strong><br/>
          Chez mySofie on a créé une gamme de <strong>surcomplémentaire intelligente</strong>{' '}
          qui s’adapte à votre complémentaire santé. MyBooster vous permet de{' '}
          <strong>réduire jusqu’à 75% votre reste à charge.</strong>
        </StopText>
      </StopBox>
      <CtaBox>
        <CtaText>Vous souhaitez en savoir plus ?</CtaText>
        <Button href="https://souscription.mysofie.fr/web" target="_parent" color="#FF41AE">
          Voir la gamme myBooster
        </Button>
      </CtaBox>
    </>
  )
}

const StopBox = styled.div`
  margin: auto;
  padding: 10px 20px;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${mq.lg} {
    max-width: 640px;
    flex-direction: row;
  }
`

const StopAlert = styled.p`
  margin: 0;
  color: #FF41AE;
  text-transform: uppercase;
  font-size: 3.125rem;
  font-weight: bold;
  flex: 1;


  ${mq.lg} {
    font-size: 5.3rem;
  }
`

const StopText = styled.p`
  margin-right: 15px;
  flex: 1;
`

const CtaBox = styled.div`
  margin: 0 auto 3rem;
  text-align: center;
`

const Button = styled(PrimaryButton.withComponent('a'))`
  height: auto;
  padding: 0.8rem;
  color: #fff;
  display: inline-block;
  text-decoration: none;
`

const CtaText = styled.p`
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;

`

export default WidgetMyBooster